<template>
  <v-container fluid class="down-top-padding">
    <BaseBreadcrumb :title="page.title" :module_name="page.name"/>
    <v-row>
      <v-col>
        <base-table ref="base_table" :page="page" @create="create" @edit="edit"/>
      </v-col>
    </v-row>
    <create-field ref="create_field" modal_name="create_field" @refresh="reload"/>
    <edit-field ref="edit_field" modal_name="edit_field" @refresh="reload"/>
  </v-container>
</template>

<script>
import CreateField from "./Create";
import EditField from "./Edit";
import BaseTable from "../../components/commonComponents/BaseTable";
import BaseBreadcrumb from "../../components/commonComponents/BaseBreadcrumb";
import helpFunctions from "../../plugins/helpFunctions";

export default {
  components: {
    BaseTable,
    BaseBreadcrumb,
    CreateField,
    EditField,
  },
  data() {
    return {
      page: helpFunctions.pages.fields,
    };
  },
  methods: {
    create(selected_model) {
      this.$refs.create_field.record.model_type = selected_model;
      this.$refs.create_field.openModal('create_field');
    },
    edit(item) {
      this.$refs.edit_field.load(item.id);
    },
    reload() {
      this.$refs.base_table.run();
    },
  },
};
</script>